export const CNT_1 = 'CNT-1'
export const CNT_2 = 'CNT-2'
